export default configuration => {
    var anchor = document.querySelector(configuration.anchor);
    if (anchor) anchor.scrollTo(configuration.x,configuration.y);
};